import apiAccount from '@/api/account'

export const useStaffStore = defineStore('staff', {
  state: () => ({
    id: '', // 员工id
    staffInfo: null // 员工信息
  }),

  actions: {
    /**
     * 获取当前登录员工信息
     * @param commit
     * @param data
     */
    async getStaffInfo() {
      const { data } = await apiAccount.getStaffInfo()
      this.id = data.id
      this.staffInfo = data
    },

    /**
     * 清除员工信息
     * @param commit
     */
    clearStaffInfo() {
      // 将state的值还原成默认值
      this.$reset()
    }
  }
})
